/**
 * Embudo CAPI 1-2-3-4. El admin elige etapas de su pipeline;
 * LeadCEM traduce a eventos Meta (Lead → Contact → Schedule → Purchase).
 */
export const EMBUDO = [
  {
    paso: 1,
    evento: 'Lead',
    titulo: 'Llegó el lead',
    ayuda: 'El anuncio funcionó: esta persona ya está en LeadCEM.',
    meta_recibe: 'hay un lead nuevo',
  },
  {
    paso: 2,
    evento: 'Contact',
    titulo: 'Lo contactamos',
    ayuda: 'Alguien (o la IA) ya habló con él. Empieza a perfilarse.',
    meta_recibe: 'se está perfilando',
  },
  {
    paso: 3,
    evento: 'Schedule',
    titulo: 'Agendó cita o visita',
    ayuda: 'Se comprometió a verse. Prospecto caliente.',
    meta_recibe: 'está caliente',
  },
  {
    paso: 4,
    evento: 'Purchase',
    titulo: 'Cerró / compró',
    ayuda: 'Vendiste. Meta buscará gente parecida a este cliente.',
    meta_recibe: 'así se ve quien sí compra',
  },
];

export function picksFromMap(stageMap, embudo = EMBUDO) {
  const picks = {};
  const map = stageMap || {};
  for (const step of embudo) {
    const found = Object.entries(map).find(([, ev]) => ev === step.evento);
    picks[step.evento] = found ? String(found[0]) : '';
  }
  return picks;
}

export function mapFromPicks(picks) {
  const out = {};
  for (const [evento, stageId] of Object.entries(picks || {})) {
    if (stageId) out[stageId] = evento;
  }
  return out;
}

export function applyPick(picks, evento, stageId) {
  const next = { ...picks, [evento]: stageId || '' };
  if (stageId) {
    for (const k of Object.keys(next)) {
      if (k !== evento && next[k] === stageId) next[k] = '';
    }
  }
  return next;
}

export function picksFromSugerido(sugerido, embudo = EMBUDO) {
  return picksFromMap(sugerido || {}, embudo);
}

export function labelEvento(evento, embudo = EMBUDO) {
  return (embudo.find((e) => e.evento === evento) || {}).titulo || evento;
}
